var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8916 8.55805C19.8228 8.38064 19.7197 8.21857 19.5881 8.08112L12.3618 0.854847C12.2271 0.720093 12.0671 0.613202 11.891 0.540274C11.715 0.467346 11.5263 0.42981 11.3357 0.42981C10.9508 0.42981 10.5817 0.5827 10.3096 0.854847C10.1748 0.9896 10.0679 1.14958 9.99498 1.32564C9.92205 1.5017 9.88451 1.69041 9.88451 1.88098C9.88451 2.26585 10.0374 2.63496 10.3096 2.90711L15.0789 7.66199H2.25312C1.86981 7.66199 1.5022 7.81426 1.23117 8.0853C0.960129 8.35634 0.807861 8.72394 0.807861 9.10725C0.807861 9.49055 0.960129 9.85816 1.23117 10.1292C1.5022 10.4002 1.86981 10.5525 2.25312 10.5525H15.0789L10.3096 15.3074C10.1741 15.4417 10.0666 15.6016 9.9932 15.7777C9.91983 15.9538 9.88205 16.1427 9.88205 16.3335C9.88205 16.5243 9.91983 16.7132 9.9932 16.8893C10.0666 17.0654 10.1741 17.2253 10.3096 17.3596C10.4439 17.4951 10.6038 17.6026 10.7799 17.676C10.956 17.7494 11.1449 17.7872 11.3357 17.7872C11.5265 17.7872 11.7154 17.7494 11.8915 17.676C12.0676 17.6026 12.2275 17.4951 12.3618 17.3596L19.5881 10.1334C19.7197 9.99593 19.8228 9.83385 19.8916 9.65644C20.0361 9.30458 20.0361 8.90991 19.8916 8.55805Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightarrow);
export default __webpack_public_path__ + "static/media/right arrow.e41bc46838ca190f9dbeddc746a3eda3.svg";
export { ForwardRef as ReactComponent };